/**
 * @file index.tsx
 *
 * @fileoverview Shows content inside a landing page row.
 */

import React from "react";
import { ColorsProps, generateColorClasses } from "../../../../theme/colors";
import {
  generateMarginClasses,
  generatePaddingClasses,
  SpaceProps,
} from "../../../../theme/spacing";
import styles from "./simpleText.module.scss";

type BaseSimpleTextRowProps = SpaceProps & ColorsProps;
export interface SimpleTextProps extends BaseSimpleTextRowProps {
  /**
   * The content to show.
   */
  children: React.ReactNode;
}
/**
 * This component provides a simple text.
 */
export const SimpleText = ({ children, ...props }: SimpleTextProps) => {
  return (
    <div
      className={`
      ${styles.simpleTextText}
      ${generateColorClasses(props, styles)}
      ${generateMarginClasses(props, styles)}
      ${generatePaddingClasses(props, styles)}
    `.trim()}
    >
      {children}
    </div>
  );
};

export default SimpleText;
